'use strict';

var cov_qo681cy34 = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/app.js',
      hash = '920894e7b14e81deab7a0af460e2198c9349442f',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/app.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 27
        },
        end: {
          line: 4,
          column: 42
        }
      },
      '1': {
        start: {
          line: 6,
          column: 17
        },
        end: {
          line: 6,
          column: 35
        }
      },
      '2': {
        start: {
          line: 12,
          column: 27
        },
        end: {
          line: 16,
          column: 1
        }
      },
      '3': {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 15,
          column: 3
        }
      },
      '4': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 44
        }
      },
      '5': {
        start: {
          line: 22,
          column: 24
        },
        end: {
          line: 26,
          column: 44
        }
      },
      '6': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 26,
          column: 44
        }
      },
      '7': {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 39,
          column: 3
        }
      },
      '8': {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 48
        }
      },
      '9': {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 16
        }
      },
      '10': {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 33
        }
      },
      '11': {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 45,
          column: 3
        }
      },
      '12': {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 41
        }
      },
      '13': {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 72
        }
      },
      '14': {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 46,
          column: 24
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 12,
            column: 27
          },
          end: {
            line: 12,
            column: 28
          }
        },
        loc: {
          start: {
            line: 12,
            column: 41
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 12
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 22,
            column: 24
          },
          end: {
            line: 22,
            column: 25
          }
        },
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 26,
            column: 44
          }
        },
        line: 23
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 35,
            column: 15
          },
          end: {
            line: 35,
            column: 16
          }
        },
        loc: {
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 35
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        }, {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        }],
        line: 13
      },
      '1': {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 26,
            column: 44
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 21
          }
        }, {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 35
          }
        }, {
          start: {
            line: 25,
            column: 3
          },
          end: {
            line: 25,
            column: 43
          }
        }, {
          start: {
            line: 25,
            column: 47
          },
          end: {
            line: 25,
            column: 93
          }
        }, {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 44
          }
        }],
        line: 23
      },
      '2': {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }, {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }],
        line: 36
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0, 0, 0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cookiesConsent = require('./components/cookies-consent');

var _cookiesConsent2 = _interopRequireDefault(_cookiesConsent);

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CRM_MESSAGEBUS_KEY = (cov_qo681cy34.s[0]++, 'crmMessageBus');

var logError = (cov_qo681cy34.s[1]++, (0, _logger2.default)('error'));

/**
 * Sets a global object with the messageBus instance to be used by analytics.
 * @param {Object} messageBus
 */
cov_qo681cy34.s[2]++;
var setMessageBusConst = function setMessageBusConst(messageBus) {
  cov_qo681cy34.f[0]++;
  cov_qo681cy34.s[3]++;

  if (!window[CRM_MESSAGEBUS_KEY]) {
    cov_qo681cy34.b[0][0]++;
    cov_qo681cy34.s[4]++;

    window[CRM_MESSAGEBUS_KEY] = messageBus;
  } else {
    cov_qo681cy34.b[0][1]++;
  }
};

/**
 * checks if the messageBus received is correct
 * @param {Object} messageBus a messageBus instance
 */
cov_qo681cy34.s[5]++;
var checkMessageBus = function checkMessageBus(messageBus) {
  cov_qo681cy34.f[1]++;
  cov_qo681cy34.s[6]++;
  return (cov_qo681cy34.b[1][0]++, messageBus !== null) && (cov_qo681cy34.b[1][1]++, typeof messageBus !== 'undefined') && ((cov_qo681cy34.b[1][2]++, typeof messageBus.publish === 'function') || (cov_qo681cy34.b[1][3]++, typeof messageBus.publishSticky === 'function')) && (cov_qo681cy34.b[1][4]++, typeof messageBus.subscribe === 'function');
};

/**
 * function that inits all the components available
 * @function
 * @param {Object} messageBus A messageBus instance
 * @param {string} langCode A language code
 * @returns {void}
 */

exports.default = function (messageBus, langCode) {
  cov_qo681cy34.f[2]++;
  cov_qo681cy34.s[7]++;

  if (!checkMessageBus(messageBus)) {
    cov_qo681cy34.b[2][0]++;
    cov_qo681cy34.s[8]++;

    logError('POPOVERS: no messageBus defined');
    cov_qo681cy34.s[9]++;
    return null;
  } else {
    cov_qo681cy34.b[2][1]++;
  }
  cov_qo681cy34.s[10]++;
  setMessageBusConst(messageBus);
  cov_qo681cy34.s[11]++;
  try {
    cov_qo681cy34.s[12]++;

    (0, _cookiesConsent2.default)(messageBus, langCode);
  } catch (e) {
    cov_qo681cy34.s[13]++;

    logError('POPOVERS: error initializating cookie banner', e.message);
  }
  cov_qo681cy34.s[14]++;
  return _cookiesConsent2.default;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@wh/overlay-messaging/dist/app.js
// module id = 4
// module chunks = 0